import { useFeatureFlags } from "@/features/config/useFeatureFlags";
import heroAccent from "@/features/home/assets/hero-accent.png";
import heroInk from "@/features/home/assets/hero-ink.png";
import { PapersGraphic } from "@/features/home/components/PapersGraphic";
import { Link } from "react-router-dom";

/**
 * The home page's masthead + interactive showcase, shared by the home route and
 * the chat empty state. `graphicClassName` lets the host fade the showcase
 * (home does this when a side panel opens).
 */
export const HomeHero = ({
  graphicClassName = "",
  children,
}: {
  graphicClassName?: string;
  children?: React.ReactNode;
}) => {
  const { flags } = useFeatureFlags();
  return (
    <>
      <div>
        {/* Two-ink dither illustration shipped as alpha masks so it re-inks per theme. Flag-gated. */}
        {flags.homeHeroArt && (
          <div className="home-hero-art mb-7" aria-hidden>
            <div
              className="home-hero-art-layer home-hero-art-ink"
              style={{ WebkitMaskImage: `url(${heroInk})`, maskImage: `url(${heroInk})` }}
            />
            <div
              className="home-hero-art-layer home-hero-art-accent"
              style={{ WebkitMaskImage: `url(${heroAccent})`, maskImage: `url(${heroAccent})` }}
            />
          </div>
        )}
        <h1 className="font-logo text-5xl font-bold leading-[1.05] tracking-tight text-zinc-900 sm:text-6xl">
          <Link to="/" className="text-inherit no-underline">
            Paperclip <span className="whitespace-nowrap font-light">by GXL</span>
          </Link>
        </h1>
        <p className="mt-4 max-w-2xl text-base leading-6 text-zinc-500">
          An agent-native filesystem over full-text papers, clinical trials, regulatory
          documents, patents, biological databases, and much more. Everything the modern
          biotech company needs.
        </p>
      </div>

      <div className="home-stage mt-5">
        <div className={`home-stage-graphic${graphicClassName ? ` ${graphicClassName}` : ""}`}>
          <PapersGraphic />
        </div>
        {children}
      </div>
    </>
  );
};
